import React, { useContext, useEffect, useState } from "react";
import { API } from "../conf";
import { Context } from "../App";
import { Backdrop, Box, Button, CircularProgress, Dialog, IconButton, InputAdornment, TableCell, TextField, Typography } from "@mui/material";
import { Close, Edit, InfoOutlined, Search } from "@mui/icons-material";
import { getLimitePetiteCaisse } from '../utils/dateUtils';
import moment from 'moment';
import Header from "../Components/layout/Header";
import EgliseForm from "./eglise-form";
import SorTableCheckable from "../Components/ui/sortable-checkable";

export default function Eglises() {
    const user = JSON.parse(sessionStorage.getItem('user'))
    const {updateConnect, exercice} = useContext(Context)
    const [load, setLoad] = useState(true)
    const [eglises, setEglises] = useState([])
    const [eglise, setEglise] = useState()
    const [pcCompte, setPcCompte] = useState(null)
    const [search, setShearch] = useState('')
    const [selectItems, setItems] = useState([])
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('')

    const table = [
        {header: "Nom", sortable: true, sortBy:(el)=>el.nom.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.nom}</TableCell>},
        {header: "Adresse", sortable: true, sortBy:(el)=>(el.adresse1+' '+el.adresse2).toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.adresse1+', '+row.adresse2}</TableCell>},
        {header: "Code postal", sortable: true, sortBy:(el)=>el.zip_code, row: (row, index)=><TableCell key={index} sx={{maxWidth:'70px', textAlign:'center'}}>{row.zip_code}</TableCell>},
        {header: "Commune", sortable: true, sortBy:(el)=>el.commune.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.commune}</TableCell>},
        {header: "Comptes bancaire", sortable: true, sortBy:(el)=>el.have_banque ? 1 : -1, row: (row, index)=><TableCell key={index} style={{textAlign:'center'}}>{row.have_banque ? 'oui' : 'non'}</TableCell>},
        {header: "", sortable: false, row: (row, index)=><TableCell key={index} sx={{minWidth:'50px'}} >
            <IconButton aria-label="modifier" onClick={()=>{setEglise(row); manage_dialog(true, 'edit')}}><Edit fontSize="small"/></IconButton>
            <IconButton aria-label="informations complémentaires" onClick={()=>{setEglise(row); manage_dialog(true, 'info')}}><InfoOutlined fontSize="small"/></IconButton>
        </TableCell>}
    ]

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(item) {
        return item.nom+' '+item.adresse1+' '+item.adresse2+' '+item.zip_code+' '+item.commune
    }

    function manage_dialog(status, action) {
        setOpen(status); setAction(action)
        if (!status) {
            setEglise()
        } 
    }

    useEffect(()=>{
        if (!eglise || action !== 'info' || eglise.type !== 'église') { setPcCompte(null); return }
        const query = new URLSearchParams({ eglise: eglise.number, type: 'petite-caisse', exercice }).toString()
        fetch(API.concat(`/comptes/by?${query}`), { method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem('token') } })
            .then(async res => { if (res.status === 200) { const json = await res.json(); setPcCompte(json[0] ?? null) } })
    }, [eglise, action])

    useEffect(()=>{
        async function get_eglises() {
            fetch(API.concat(user.role.includes('administrateur')? '/eglises' : `/eglises/by/${JSON.stringify(user.eglises.length>0?{type: 'église', _id: {$in: user.eglises}}:{type: 'église'})}`), {method:'GET', headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }}).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setEglises(json); setLoad(false)
                    }else setLoad(false)
                }
            
            })
        } 

        get_eglises()
    }, [updateConnect, user])

    return(
        <Box display='flex' flex={1} flexDirection='column' marginBottom='30px'>
            <Header/>
            <Typography variant="h4" align="center" marginY={5}>Gestion des églises</Typography>
            <Box display='flex' justifyContent='space-between' alignItems='center' marginX='30px'>
                <TextField placeholder="Rechercher une église" size="small" sx={{width:'60%', minWidth:'400px'}} value={search} onChange={e=>setShearch(e.target.value)}
                InputProps={{endAdornment: (<InputAdornment position="end"><Search/></InputAdornment>)}}/>
                <Button variant="contained" onClick={()=>manage_dialog(true, 'add')}>Ajouter</Button>
            </Box>

            <div style={{marginInline:'30px'}}><SorTableCheckable data={eglises.filter(log=> normalize(get_searchable(log)).includes(normalize(search)))} selectItems={selectItems} setItems={setItems} table={table} rowsPerPage={50} rowsPerPageOptions={[25, 50, 100, 300]}/></div>

            <Backdrop open={load}><CircularProgress/></Backdrop>
            <Dialog open={open} fullWidth maxWidth={action==='info'?'xs':'md'} onClose={()=>manage_dialog(false, '')}>
                <IconButton onClick={()=>manage_dialog(false, '')} sx={{alignSelf:'end', marginTop:'5px', marginRight:'5px'}}><Close/></IconButton>
                {action==='info'&& <Box marginX='20px' marginBottom='20px'>
                    <Typography variant="subtitle1" align="center" marginBottom='15px' sx={{textTransform:'capitalize'}}>{eglise.nom+' ('+eglise.commune+')'}</Typography>
                    <Typography>Fédération: {eglise.type==='fédération'?'oui':'non'}</Typography>
                    {pcCompte?.limite_temp && pcCompte?.limite_temp_expiration && new Date(pcCompte.limite_temp_expiration) > new Date()
                        ? <>
                            <Typography>Limite petite caisse: <strong>{pcCompte.limite_temp.toFixed(2)}€</strong> (temporaire jusqu'au {moment.utc(pcCompte.limite_temp_expiration).format('DD/MM/YYYY')})</Typography>
                            <Typography variant="body2" color="text.secondary">Limite permanente: {eglise.limite_petite_caisse?.toFixed(2)}€</Typography>
                          </>
                        : <Typography>Limite petite caisse: {getLimitePetiteCaisse(eglise, pcCompte).toFixed(2)}€</Typography>
                    }
                    {eglise.type==='église'&&<Typography>Peut effectuer des versements vers un compte bancaire fédéral: {eglise.can_verse_bqfeam?'oui':'non'}</Typography>}
                </Box>}
                {action==='add'&& <EgliseForm add={eg=> setEglises(old=>[...old, eg])} close={()=>manage_dialog(false, '')} />}
                {action==='edit'&&eglise&& <EgliseForm edit={true} eglise={eglise} add={eg=> setEglises(old=>{const updated=[...old]; updated[old.findIndex(item=>item._id===eg._id)]=eg; return updated})} close={()=>manage_dialog(false, '')} />}
            </Dialog>
        </Box>
    )
}